const PDFgeneration = () => {
  return <div></div>;
};

export default PDFgeneration;
